export interface QuestionOption {
  optionId: string;
  description: string;
}

export interface Question {
  questionId: string;
  description: string;
  detail?: string;
  isObligatory: boolean;
  options: QuestionOption[];
}

export interface QuestionsResponse {
  success: boolean;
  questions: Question[];
}

export type QuestionType = 'control' | 'knowledge';

export interface Answer {
  idQuestion: string;
  idOption: string;
}

export interface SubmitAnswersRequest {
  answers: Answer[];
}

export interface SubmitAnswersResponse {
  success: boolean;
  approved: boolean;
  message: string;
}

/**
 * Parser del campo `detail` que viene del backend.
 * Formato: "texto principal|- bullet 1|- bullet 2"
 * Compatible con el patrón usado en el flujo legacy.
 */
export function parseQuestionDetail(detail?: string): {
  main: string;
  bullets: string[];
} {
  if (!detail) {
    return { main: '', bullets: [] };
  }

  const parts = detail
    .split('|')
    .map((p) => p.trim())
    .filter(Boolean);

  const main = parts.find((p) => !p.startsWith('-')) ?? '';
  const bullets = parts
    .filter((p) => p.startsWith('-'))
    .map((p) => p.replace(/^-+/, '').trim());

  return { main, bullets };
}
